import React, { useState, useRef, useEffect } from 'react'

import { Grid as BaseGrid, styled, ClickAwayListener } from '@mui/material'
import { makeStyles } from '@mui/styles'

import {
  Radio as BaseRadio,
  Textarea as BaseTextArea,
  Tooltip as BaseTooltip,
  LinkButton as BaseButton
} from '@chilecompra/react-kit/components'
import { TooltipIcon } from '@chilecompra/react-kit/components/Inputs/Input.styles'

const useTooltipGlobalStyles = makeStyles({
  '@global': {
    '.MuiTooltip-popper.MuiTooltip-popperArrow': {
      '& .MuiTooltip-tooltip': {
        maxHeight: 'unset',

        '& div': {
          maxHeight: 'unset',
          '& span': {
            hyphens: 'none'
          }
        }
      }
    },
    '.MuiFormGroup-root': {
      gridTemplateColumns: 'repeat(auto-fit,minmax(10px,1fr)) !important',
      gridColumnGap: '10px !important'
    },
    '.pointer': {
      cursor: 'pointer'
    },
    '.MuiTooltip-popper': {
      pointerEvents: 'bounding-box'
    }
  }
})

export const DeclarationWrapper = styled('div')`
  border: 1px solid ${props => props.theme.palette.gray[85]};
  border-radius: 5px;
  height: 300px;
  overflow-y: scroll;
  padding: 18px;
`
export const DialogWrapper = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px;
`
export const Grid = styled(BaseGrid)`
  margin: ${props => props.margin};
  text-align: ${props => props.textAlign};
  border: ${props => props.border};
  width: 100%;
  border-radius: ${props => props.borderRadius};
  padding: ${props => props.padding};
`
export const LineJump = styled('br')``

export const TextArea = styled(({ ...props }) => {
  useTooltipGlobalStyles()

  return <BaseTextArea {...props} />
})``

export const RadioWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 10rem;
  margin-top: 0.5rem;
`

export const Radio = styled(({ ...props }) => {
  useTooltipGlobalStyles()

  return (
    <RadioWrapper>
      <BaseRadio {...props} />
    </RadioWrapper>
  )
})``

export const Tooltip = styled(({ ...props }) => {
  useTooltipGlobalStyles()
  const tooltipRef = useRef(null)
  const [open, setOpen] = useState(false)

  const handleTooltipClose = () => {
    setOpen(false)
  }

  const handleTooltipOpen = () => {
    setOpen(true)
  }

  const handleClickOutside = event => {
    if (tooltipRef.current && !tooltipRef.current.contains(event.target)) {
      handleTooltipClose()
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <ClickAwayListener onClickAway={handleTooltipClose}>
      <div ref={tooltipRef} onMouseEnter={() => handleTooltipOpen()} onMouseLeave={() => handleTooltipClose()}>
        <BaseTooltip
          PopperProps={{
            disablePortal: true
          }}
          disableFocusListener
          disableHoverListener
          disableTouchListener
          open={open}
          {...props}
        >
          <span className="pointer" onClick={() => handleTooltipOpen()}>
            <TooltipIcon size={props?.size} />
          </span>
        </BaseTooltip>
      </div>
    </ClickAwayListener>
  )
})``

export const LinkButton = styled(({ ...props }) => <BaseButton {...props} />)`
  color: ${props => props.renamedColor || '#fff'} !important;
  height: auto !important;
  text-decoration: underline !important;
  background-color: transparent !important;
  display: inline !important;
  padding-left: 0.4rem !important;
  line-height: initial !important;
`

export const StrongSpam = styled('span')`
  font-weight: bold;
  color: ${props => props.theme.palette.brand.black1};
`
